/** @typedef {import('../poker/cards.js').Card} Card */

export const START_BANKROLL = 1500;
export const MIN_BET = 10;
export const MAX_BET = 500;
export const BET_STEP = 5;
export const BET_PRESETS = [10, 25, 50, 100];

/** Natural blackjack pays num/den (e.g. 3/2). */
export const BLACKJACK_NUMERATOR = 3;
export const BLACKJACK_DENOMINATOR = 2;

/** House rule: false = stand on soft 17 (recommended). */
export const DEALER_HITS_SOFT_17 = false;

export const NUM_DECKS = 6;
/** Reshuffle when fewer cards remain (before a round). */
export const PENETRATION_MIN_CARDS = 40;

export const ALLOW_DOUBLE_AFTER_SPLIT = true;

/** Center seat: left = index 0 (AI), hero = 1, right = 2 (AI). */
export const HERO_SEAT_INDEX = 1;
/** Human + 2 AI */
export const NUM_PLAYER_SEATS = 3;

export const TABLE_ID = 21;
